<div class="row my-3 mx-3">
    <div class="row">
        <div class="d-flex flex-column mb-4">
            <h1 class="sub-header-title">Add/Remove Country</h1>
        </div>
    </div>
    <div class="row mt-3">
        <div class="row mt-3 policy-form">
            <div class="d-flex flex-column">
                <h2 class="sub-form-header-title">Available Countries</h2>
            </div>
        </div>
        <div class="row mt-3 mb-5 policy-form">
            <div class="col d-flex flex-column">
                <mat-form-field appearance="fill">        
                    <mat-chip-grid #chipList aria-label="Fruit selection">
                        <mat-chip *ngFor="let country of countries" (removed)="remove(country)">
                            {{ country }}
                            <button matChipRemove>
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip>
                        <input #countryInput placeholder="Search Countries..." [formControl]="countryControl"
                            [matAutocomplete]="auto" [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)">
                    </mat-chip-grid>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectCountries($event)">
                        <ng-container *ngFor="let country of filteredCountries | async">
                            <mat-option *ngIf="!countries.includes(country.display_text)" [value]="country">
                                {{ country.display_text }}
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="mt-2 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancel()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" (click)="onSaveChanges()">
            <mat-icon>check</mat-icon>
            Save Changes
        </button>
    </div>
</div>